var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2501 14.65V18.9C20.2501 19.994 19.4631 20.936 18.3781 21.08C16.2911 21.357 14.1621 21.5 12.0001 21.5C9.83806 21.5 7.70906 21.357 5.62206 21.08C4.53706 20.936 3.75006 19.994 3.75006 18.9V14.65M20.2501 14.65C20.4875 14.4436 20.6775 14.1883 20.807 13.9016C20.9364 13.6149 21.0023 13.3036 21.0001 12.989V9.206C21.0001 8.125 20.2321 7.191 19.1631 7.031C18.0304 6.86142 16.892 6.73234 15.7501 6.644M20.2501 14.65C20.0561 14.815 19.8301 14.945 19.5771 15.03C17.1333 15.8408 14.5748 16.2528 12.0001 16.25C9.35206 16.25 6.80506 15.821 4.42306 15.03C4.17631 14.9479 3.94778 14.8189 3.75006 14.65M3.75006 14.65C3.5126 14.4436 3.32262 14.1883 3.19315 13.9016C3.06369 13.6149 2.99782 13.3036 3.00006 12.989V9.206C3.00006 8.125 3.76806 7.191 4.83706 7.031C5.96975 6.86142 7.10814 6.73233 8.25006 6.644M15.7501 6.644V5.75C15.7501 5.15326 15.513 4.58097 15.091 4.15901C14.6691 3.73705 14.0968 3.5 13.5001 3.5H10.5001C9.90332 3.5 9.33102 3.73705 8.90907 4.15901C8.48711 4.58097 8.25006 5.15326 8.25006 5.75V6.644M15.7501 6.644C13.2538 6.45108 10.7463 6.45108 8.25006 6.644M12.0001 13.25H12.0081V13.258H12.0001V13.25Z",
    stroke: "#8893AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCase);
export default __webpack_public_path__ + "static/media/gray-case.ddc4a528dc935f5abcec7f364958f75b.svg";
export { ForwardRef as ReactComponent };